<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
  <!--<div class="form-horizontal">-->

  <div class="form-group row">
    <div class="col-md-10">
      <yt-input [Type]="'text'" 
                [Label]="'OSNOVZAPLACENOODSUSTVO.NAZIV.SINGULAR'" name="txtNaziv" #autofocus
                autocomplete="off" 
                formControlName="Naziv" 
                #Naziv 
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
        <span *ngFor="let validation of errorMessages.Naziv">
          <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
  </div>
</div>
    <div class="form-group row">
      <div class="col-md-10">
        <yt-input [Type]="'text'" 
                  [Label]="'OSNOVZAPLACENOODSUSTVO.MIN_BROJ_DANA.SINGULAR'" 
                  name="txtmin_broj_dana"
                  #autofocus 
                  autocomplete="off" 
                  formControlName="min_broj_dana" 
                  #Naziv 
                  [ngClass]="{'is-invalid': submitted && fc.min_broj_dana.invalid}">
        </yt-input>
        <div class="form-error" *ngIf="submitted && fc.min_broj_dana.invalid">
          <span *ngFor="let validation of errorMessages.min_broj_dana">
            <span class="error-message" *ngIf="fc.min_broj_dana.hasError(validation.type)">
              <span translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>

  
</form>